class Pagintaion {
    constructor(item) {
        // Переменные
        this.element = item;
        this.items = this.element.querySelectorAll('.js-pagination-item');

        // Функции
        this.setListeners();
        this.setPagintion();
    };

    setListeners() {
        window.addEventListener('resize', () => {
            this.setPagintion();
        });
    }

    setPagintion() {
        if (window.innerWidth < 768) {
            if (this.items.length <= 4) { // Если страниц меньше 5, то все отображаются
                this.items.forEach(item => {
                    item.style.display="flex"
                });
            } else if (this.items[0].classList.contains('is-active')) { // Если активная страница первая
                this.items[1].style.display="flex";

                if (!this.element.querySelector('.js-pagination-item-dotes')) {
                    this.items[1].insertAdjacentHTML('afterend', '<span class="pagination__item js-pagination-item-dotes" style="display: flex;"><span>...</span></span>');
                }
            } else if (this.items[this.items.length - 1].classList.contains('is-active')) { // Если активная страница последняя
                this.items[this.items.length - 2].style.display="flex";

                if (!this.element.querySelector('.js-pagination-item-dotes')) {
                    this.items[this.items.length - 2].insertAdjacentHTML('beforebegin', '<span class="pagination__item js-pagination-item-dotes" style="display: flex;"><span>...</span></span>');
                }
            } else if (this.items[1].classList.contains('is-active')) { // Если активная страница вторая
                if (!this.element.querySelector('.js-pagination-item-dotes')) {
                    this.items[1].insertAdjacentHTML('afterend', '<span class="pagination__item js-pagination-item-dotes" style="display: flex;"><span>...</span></span>');
                }
            } else if (this.items[this.items.length - 2].classList.contains('is-active')) { // Если активная страница вторая с конца
                if (!this.element.querySelector('.js-pagination-item-dotes')) {
                    this.items[this.items.length - 2].insertAdjacentHTML('beforebegin', '<span class="pagination__item js-pagination-item-dotes" style="display: flex;"><span>...</span></span>');
                }
            } else { // Условие, если страница где-то в центре
                if (!this.element.querySelector('.js-pagination-item-dotes')) {
                    this.items[this.items.length - 2].insertAdjacentHTML('afterend', '<span class="pagination__item js-pagination-item-dotes" style="display: flex;"><span>...</span></span>');
                }
            }
        } else if (window.innerWidth >= 768) {
            if (this.element.querySelector('.js-pagination-item-dotes')) {
                this.element.querySelector('.js-pagination-item-dotes').remove();
            }
        }
    }
};

document.querySelectorAll('.js-pagination').forEach((item) => new Pagintaion(item));
